import { useContext } from 'react';
import { AlertContext } from './alertProvider';

export default function useAlert() {
    return useContext(AlertContext);
}
